import { createContext, useContext, useState, ReactNode } from "react";

interface OpenOptions {
  prefillTenantId?: string;
}

interface TenantSelectionContextType {
  isOpen: boolean;
  open: (options?: OpenOptions) => void;
  close: () => void;
  prefillTenantId?: string;
}

const TenantSelectionContext = createContext<TenantSelectionContextType>({
  isOpen: false,
  open: () => {},
  close: () => {},
  prefillTenantId: undefined,
});

export const TenantSelectionProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [prefillTenantId, setPrefillTenantId] = useState<string | undefined>();

  const open = (options?: OpenOptions) => {
    setPrefillTenantId(options?.prefillTenantId);
    setIsOpen(true);
  };
  const close = () => {
    setIsOpen(false);
    setPrefillTenantId(undefined);
  };

  return (
    <TenantSelectionContext.Provider
      value={{
        isOpen,
        open,
        close,
        prefillTenantId,
      }}
    >
      {children}
    </TenantSelectionContext.Provider>
  );
};

export const useTenantSelection = () => useContext(TenantSelectionContext);
